// Tela 5 — Título + subtítulo + duas colunas. Extraído de
// entrevista-sergio-gargantini.html (bloco #s4). Ver DOCS/05-aprendizado.md.
//
// Título é text-align:right e subtítulo text-align:left DE PROPÓSITO — as
// duas colunas se encontram no centro do card com bordas internas limpas.
// Não é bug, é a composição do design original — não inverter.
import { toBrLines, toFlowText } from '../shared/text'
import { LOGO_PRETO_DATA_URI } from '../shared/logo'
import type { TemplateDefinition } from '../types'

export const CSS = `
  .tpl-aprendizado{
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    padding:40px 40px 70px;
    position:relative;
  }
  .tpl-aprendizado .head-row{
    display:flex;
    align-items:center;
    justify-content:center;
    gap:2.5%;
    flex:1;
    min-height:0;
    padding-top:28px;
    padding-bottom:34px;
  }
  .tpl-aprendizado .title4{
    flex:0 0 52%;
    height:216px;
    display:flex;
    align-items:center;
    justify-content:flex-end;
    font-family:'Anton',sans-serif;
    font-size:clamp(30px,var(--template-vw-7-6, 7.6vw),49px);
    line-height:.98;
    letter-spacing:-.01em;
    text-align:right;
    max-width:52%;
  }
  .tpl-aprendizado .title4-text{
    display:block;
    transform:scaleY(1.5);
    transform-origin:center right;
  }
  .tpl-aprendizado .sub4{
    font-family:'Big Shoulders',sans-serif;
    font-weight:200;
    font-size:clamp(13.6px,var(--template-vw-3-15, 3.15vw),20px);
    line-height:1.5;
    letter-spacing:.02em;
    max-width:44%;
  }
  .tpl-aprendizado .cols{
    display:grid;
    grid-template-columns:1fr 1fr;
    gap:5%;
    flex:0 0 auto;
  }
  .tpl-aprendizado .cols p{
    font-family:'Source Serif 4',serif;
    font-weight:300;
    font-size:clamp(11.5px,var(--template-vw-2-15, 2.15vw),13.5px);
    line-height:1.78;
    text-align:justify;
  }
  .tpl-aprendizado .logo{position:absolute; top:40px; right:40px; height:22px;}
`

function render(content: Record<string, unknown>): string {
  const title = toBrLines(String(content.title ?? ''))
  const subtitle = toBrLines(String(content.subtitle ?? ''))
  const col1 = toFlowText(String(content.col1 ?? ''))
  const col2 = toFlowText(String(content.col2 ?? ''))

  return `<section class="slide tpl-aprendizado">
    <div class="head-row">
      <h2 class="title4 reveal r1"><span class="title4-text">${title}</span></h2>
      <p class="sub4 reveal r2">${subtitle}</p>
    </div>
    <div class="cols">
      <p class="reveal r3">${col1}</p>
      <p class="reveal r4">${col2}</p>
    </div>
    <div class="logo reveal r5"><img src="${LOGO_PRETO_DATA_URI}" alt="Lorena"></div>
  </section>`
}

export const aprendizadoTemplate: TemplateDefinition = {
  id: 'aprendizado',
  label: 'Título + duas colunas',
  tags: ['homem', 'texto'],
  css: CSS,
  fieldsSchema: [
    {
      key: 'title',
      label: 'Título',
      type: 'textarea',
      help: 'Uma linha por vez — cada linha vira uma quebra manual.',
      placeholder: 'TÍTULO,\nDE EXEMPLO\nAQUI.',
    },
    { key: 'subtitle', label: 'Subtítulo', type: 'textarea', placeholder: 'Subtítulo de exemplo explicando o contexto do título ao lado.' },
    { key: 'col1', label: 'Texto corrido — coluna 1', type: 'textarea', placeholder: 'Texto corrido de exemplo para a primeira coluna...' },
    { key: 'col2', label: 'Texto corrido — coluna 2', type: 'textarea', placeholder: 'Texto corrido de exemplo para a segunda coluna...' },
  ],
  render,
  previewContent: {
    title: 'TÍTULO,\nDE EXEMPLO\nAQUI.',
    subtitle: 'Subtítulo de exemplo explicando o contexto do título ao lado.',
    col1: 'Texto corrido de exemplo para a primeira coluna, ilustrando como o parágrafo se comporta dentro do espaço disponível.',
    col2: 'Texto corrido de exemplo para a segunda coluna, com o mesmo comportamento de justificação e tamanho de fonte.',
  },
}
